import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Column.css';
import Item from '../Item/Item';

class Column extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        count: PropTypes.number,
      }),
    ).isRequired,
    linkPrefix: PropTypes.string.isRequired,
    style: PropTypes.shape(),
    location: PropTypes.shape(),
    isLast: PropTypes.bool,
    onCollapseClick: PropTypes.func.isRequired,
    lensEvent: PropTypes.string.isRequired,
    collapseBtnText: PropTypes.string,
    category: PropTypes.shape(),
  };

  static defaultProps = {
    style: {
      width: `100%`,
    },
    location: null,
    isLast: false,
    collapseBtnText: null,
    category: null,
  };

  handleCollapseClick = () => {
    this.props.onCollapseClick();
  };

  render() {
    const {
      items,
      style,
      linkPrefix,
      location,
      isLast,
      collapseBtnText,
      category,
      lensEvent,
      // linkGetRequest,
    } = this.props;
    return (
      <div className={s.root} style={style}>
        {items.map(item =>
          <Item
            displayNone={item.displayNone}
            key={`${item.id}-${item.slug}`}
            title={item.title}
            linkPrefix={linkPrefix}
            category={category}
            /* linkGetRequest={linkGetRequest} */
            slug={item.slug}
            params={item.params}
            rel={item.rel}
            count={item.count}
            location={location}
            lensEvent={lensEvent}
          />,
        )}

        {!isLast &&
          collapseBtnText &&
          <div className={s.all} onClick={this.handleCollapseClick}>
            {collapseBtnText}
          </div>}
      </div>
    );
  }
}

export default withStyles(s)(Column);



// WEBPACK FOOTER //
// ./src/desktop/components/PopularMarksModels/Column/Column.js